// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-header-sec {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 6px 16px;
  min-height: auto;
  min-height: 50px;
}
.widget-header-sec .logo-sec {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.widget-header-sec .logo-sec svg path {
  stroke: var(--AA-gloabl-text-color);
}
.widget-header-sec .logo-sec .divider-line {
  background: var(--AA-gloabl-bg-secondary);
  width: 1px;
  flex-shrink: 0;
  height: 15px;
}
.widget-header-sec .right-chart-data {
  transition: 0.2s all ease-in-out;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.widget-header-sec .right-chart-data button.settings-btn svg path {
  fill: var(--AA-gloabl-text-color);
  stroke: none !important;
}
.widget-header-sec .right-chart-data button:not(.aa-slider) {
  padding: 0;
  height: 28px;
  width: 28px;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  font-size: 18px;
  transition: 0.2s all ease;
  background: transparent;
  color: var(--AA-gloabl-text-color);
}
.widget-header-sec .right-chart-data button:not(.aa-slider) svg path {
  stroke: var(--AA-gloabl-text-color);
}
.widget-header-sec .right-chart-data button:not(.aa-slider):hover, .widget-header-sec .right-chart-data button:not(.aa-slider).active-action {
  background: var(--AA-global-theme-bg);
  color: var(--AA-global-white-color);
}
.widget-header-sec .right-chart-data button:not(.aa-slider):hover svg path, .widget-header-sec .right-chart-data button:not(.aa-slider).active-action svg path {
  stroke: var(--AA-global-white-color);
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/tabs/header/header.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AACR;AACY;EACI,mCAAA;AAChB;AAEQ;EACI,yCAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;AAAZ;AAGI;EACI,gCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AADR;AAKoB;EACI,iCAAA;EACA,uBAAA;AAHxB;AAOY;EACI,UAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,kCAAA;AALhB;AAOoB;EACI,mCAAA;AALxB;AAQgB;EACI,qCAAA;EACA,mCAAA;AANpB;AAQwB;EACI,oCAAA;AAN5B","sourcesContent":["\n.widget-header-sec{\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 6px 16px;\n    min-height: auto;\n    min-height: 50px;\n    .logo-sec{\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        width: 100%;\n        svg{\n            path{\n                stroke: var(--AA-gloabl-text-color);\n            }\n        }\n        .divider-line{\n            background: var(--AA-gloabl-bg-secondary);\n            width: 1px;\n            flex-shrink: 0;\n            height: 15px;\n        }\n    }\n    .right-chart-data{\n        transition: 0.2s all ease-in-out;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        button{\n            &.settings-btn{\n                svg{\n                    path{\n                        fill:  var(--AA-gloabl-text-color);\n                        stroke: none !important;\n                    }\n                }\n            }\n            &:not(.aa-slider){\n                padding: 0;\n                height: 28px;\n                width: 28px;\n                border: 0;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                border-radius: 100%;\n                font-size: 18px;\n                transition: 0.2s all ease;\n                background: transparent;\n                color: var(--AA-gloabl-text-color);\n                svg{\n                    path{\n                        stroke: var(--AA-gloabl-text-color);\n                    }\n                }\n                &:hover, &.active-action{\n                    background: var(--AA-global-theme-bg);\n                    color: var(--AA-global-white-color);\n                    svg{\n                        path{\n                            stroke: var(--AA-global-white-color);\n                        }\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
